import Tag from './src/tag2.mjs';
export { tagEmits, tagProps } from './src/tag.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTag = withInstall(Tag);

export { ElTag, ElTag as default };
//# sourceMappingURL=index.mjs.map
